import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'

import { integrationStatuses } from '@/configuration/pages/ConfigurationPage/IntegrationsConfigurations/constants'

import { nonToggleableStatuses } from './constants'

export const canToggleIntegration = integration => !nonToggleableStatuses.includes(integration.status)

export const getMenuItems = ({ t, onEdit, onUninstall, integration, theme }) =>
  [
    {
      id: 'edit',
      label: t('Editar'),
      icon: PencilSimpleIcon,
      onClick: () => onEdit(integration),
      visible: true,
    },
    {
      id: 'uninstall',
      label: t('Desinstalar'),
      icon: TrashIcon,
      onClick: () => onUninstall(integration),
      visible: integration?.supports_uninstall && integration?.status !== integrationStatuses.pending,
      iconColor: theme.colors.danger.onSurface,
    },
  ].filter(item => item.visible)
